import React from 'react';

import './styles.scss';

const UserEmail = ({ email = 'mail@meail.com', ...props }) => {
	return (
		<div className="user__email">
            {email}
		</div>
	)
};

export default UserEmail;
